import { get } from '../api';

const route = '/rain_scores/model1';

const getRainScore = ({ config }) => get(route, config);

export default getRainScore;
